import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Platform, View } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { INotificationsPermissionScreenViewModelType } from './INotificationsPermissionScreenViewModel';
import { component } from '../../Decorators/Component';
import { ModalScreenView } from '../ModalScreen/ModalScreenView';
import { AnimatedImageView } from '../../Components/Image/AnimatedImageView';
import { HeaderView } from '../../Components/Navigation/HeaderView';
import { AnimatedScrollView } from '../../Components/Common/AnimatedScrollView';
import { ContainerView } from '../../Components/Common/ContainerView';
import { H3View } from '../../Components/Typography/H3View';
import { ParagraphView } from '../../Components/Typography/Paragraph';
import { PrimaryButtonView } from '../../Components/Buttons/PrimaryButtonView';
import { TertiaryButtonView } from '../../Components/Buttons/TertiaryButtonView';
export const NotificationsPermissionScreenComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.notificationsPermission,
    dependencies: {
        viewModel: INotificationsPermissionScreenViewModelType
    },
    style(theme) {
        var _a, _b;
        let backgroundColor = ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary_color)
            ? (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color
            : undefined;
        if (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.startsWith('rgb(')) {
            backgroundColor = backgroundColor
                .replace('rgb(', 'rgba(')
                .replace(')', ', 0.9)');
        }
        return {
            theme: {},
            overlay: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor
            },
            body: {
                flex: 1,
                justifyContent: 'center'
            },
            footer: {
                padding: 20,
                paddingBottom: 20
            },
            image: {
                alignSelf: 'center',
                width: 220,
                height: 220,
                borderRadius: 110,
                overflow: 'hidden',
                marginBottom: 20
            },
            title: {
                textAlign: 'center',
                marginBottom: 6
            },
            description: {
                textAlign: 'center',
                marginBottom: 20
            },
            button: {
                marginBottom: 10
            }
        };
    }
})(({ style, viewModel, assets, localization, navigation }) => {
    var _a, _b, _c, _d;
    const handleOk = useCallback(() => viewModel === null || viewModel === void 0 ? void 0 : viewModel.ok(), []);
    const handleCancel = useCallback(() => viewModel === null || viewModel === void 0 ? void 0 : viewModel.cancel(), []);
    return (_jsxs(ModalScreenView, { navigation: navigation, hideHeader: true, shellStyle: Platform.OS === 'web' && { flex: 1 }, loading: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.loading, errorPopUp: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.error, onErrorDismiss: viewModel === null || viewModel === void 0 ? void 0 : viewModel.dismissError, onDismiss: viewModel === null || viewModel === void 0 ? void 0 : viewModel.close, children: [!!((_a = assets === null || assets === void 0 ? void 0 : assets.images) === null || _a === void 0 ? void 0 : _a.notifications_permission_background_url) && (_jsx(AnimatedImageView, { removeSkeleton: true, image: (_b = assets === null || assets === void 0 ? void 0 : assets.images) === null || _b === void 0 ? void 0 : _b.notifications_permission_background_url, containerStyle: style === null || style === void 0 ? void 0 : style.overlay, resizeMode: "cover" })), _jsx(HeaderView, { tintColor: '#fff', onBack: viewModel === null || viewModel === void 0 ? void 0 : viewModel.close, headerTransparent: true, isDismissButton: true, reverseHeader: true }), _jsx(AnimatedScrollView, { containerStyle: { flex: 1 }, contentContainerStyle: { minHeight: '100%' }, children: _jsxs(ContainerView, { containerStyle: style === null || style === void 0 ? void 0 : style.body, children: [!!((_c = assets === null || assets === void 0 ? void 0 : assets.images) === null || _c === void 0 ? void 0 : _c.notifications_permission_url)
                            ? (_jsx(AnimatedImageView, { image: (_d = assets === null || assets === void 0 ? void 0 : assets.images) === null || _d === void 0 ? void 0 : _d.notifications_permission_url, containerStyle: style === null || style === void 0 ? void 0 : style.image, resizeMode: "cover" }))
                            : _jsx(View, { style: style === null || style === void 0 ? void 0 : style.image }), _jsxs(View, { children: [_jsx(H3View, { textStyle: style === null || style === void 0 ? void 0 : style.title, light: true, children: (localization === null || localization === void 0 ? void 0 : localization.title) || (localization === null || localization === void 0 ? void 0 : localization.never_miss_a_deal) || 'Never miss a deal!' }), _jsx(ParagraphView, { textStyle: style === null || style === void 0 ? void 0 : style.description, light: true, children: (localization === null || localization === void 0 ? void 0 : localization.description) || 'Be notified for new content and offers' }), _jsx(PrimaryButtonView, { text: (localization === null || localization === void 0 ? void 0 : localization.accept) || (localization === null || localization === void 0 ? void 0 : localization.yes_please) || 'Yes, Please', wrapperStyle: style === null || style === void 0 ? void 0 : style.button, containerStyle: style === null || style === void 0 ? void 0 : style.theme, onPress: handleOk }), _jsx(TertiaryButtonView, { text: (localization === null || localization === void 0 ? void 0 : localization.deny) || (localization === null || localization === void 0 ? void 0 : localization.no_thanks) || 'No, Thanks', containerStyle: style === null || style === void 0 ? void 0 : style.theme, onPress: handleCancel })] })] }) })] }));
});
